import { Dispatch } from 'redux';
import { toast } from 'react-toastify';

import * as api from '../utils/api';
import { PresenceUser } from '../utils/api';

interface IPresenceState {
  onlineData: PresenceUser[];
}

const actions = {
  SET: 'lms-ui/presence/SET',
};

interface IPresenceAction {
  type: typeof actions.SET;
  payload: PresenceUser[];
}

type PresenceActionTypes = IPresenceAction;

const initialState: IPresenceState = {
  onlineData: [],
};

export const setPresenceData = (onlineData: PresenceUser[]): PresenceActionTypes => {
  return { type: actions.SET, payload: onlineData };
};

// Fetch the current presence snapshot for the initial paint and manual REFRESH.
// Surfaced through a thunk (not a direct api.* call in the component) so a failed
// fetch is visible to the operator instead of silently reading as "0 online".
export const getOnlineData = () => async (dispatch: Dispatch) => {
  try {
    const response = await api.getOnlineData();
    dispatch(setPresenceData(response.data));
  } catch (e) {
    console.error(e);
    toast.error("Unable to load who's online. Please try again.");
  }
};

export default function reducer(state = initialState, action: PresenceActionTypes): IPresenceState {
  switch (action.type) {
    case actions.SET: {
      return { ...state, onlineData: Array.isArray(action.payload) ? action.payload : [] };
    }
    default:
      return state;
  }
}
